class DossierLoadMore {
    constructor($el) {
        this.$el = $el;
        
        if(this.$el.length && this.$el[0].hasAttribute('data-page') && this.$el[0].hasAttribute('data-post-id')) {
            this.nextPage = parseInt(this.$el.attr('data-page'), 10);
            this.dossierId = parseInt(this.$el.attr('data-post-id'), 10);

            if(!isNaN(this.nextPage) && !isNaN(this.dossierId) && this.nextPage > 0 && this.dossierId > 0) {
                this._bindEvents();
            }
        }
    }

    _bindEvents() {
        this.onLoadMoreFn = this._onLoadMore.bind(this);
        this.onLoadDoneFn = this._onLoadDone.bind(this);
        this.onLoadFailFn = this._onLoadFail.bind(this);
        this.lockLoadingFn = this._lockLoading.bind(this);
        this.unlockLoadingFn = this._unlockLoading.bind(this);

        this.$el.on('click', this.onLoadMoreFn);
    }

    _onLoadMore(e) {
        e.preventDefault();
        const target = e.target;
        
        if(!target.classList.contains('loading')) {
            const formData = this._getAjaxData();
            console.log('formData:', formData);
            const request = $.ajax({
                url: cp.ajax_url,
                type: 'post',
                data: formData,
                // dataType: 'html',
                // contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                beforeSend: this.lockLoadingFn
            });
            
            request.done(this.onLoadDoneFn);
            request.fail(this.onLoadFailFn);
            request.always(this.unlockLoadingFn);
        }
    }

    _getAjaxData() {
        return {
            action: 'load_more_dossier',
            page: this.nextPage,
            post_id: this.dossierId,
            _wpnonce_dossier_load_more: cp._wpnonce_dossier_load_more
        };
    }

    _lockLoading() {
        this.$el.addClass('loading');
    }

    _unlockLoading() {
        this.$el.removeClass('loading');
    }

    _onLoadDone(response, textStatus, jqXHR) {
        const $dossierContentPlaceholder = $('#dossier-content-placeholder');
        
        if($dossierContentPlaceholder.length) {
            $dossierContentPlaceholder.replaceWith(response.data.results);
        }
        
        if(response.data.next_page !== -1) {
            this.nextPage = response.data.next_page;
            this.$el.attr('data-page', response.data.next_page);
        }
        else {
            this.$el.remove();
        }
    }

    _onLoadFail(jqXHR, textStatus, errorThrown) {
        console.log('onLoadFail', jqXHR, textStatus, errorThrown);  
    }
}

export default DossierLoadMore;